<template>
  <div>
    Automatischer Logout bei Inaktivität in
    {{ convertedExpInSecCounter }} Minuten.
    <BeforeLogoutDialog ref="beforeLogoutDialog" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BeforeLogoutDialog from '@/components/global_components/dialogs/BeforeLogoutDialog';

const SECONDS_TO_TRIGGER_LOGOUT_DIALOG = 60;

export default {
  name: 'TokenTimeoutCountdown',
  components: { BeforeLogoutDialog },
  computed: {
    ...mapGetters('tokenCounter', ['getExpInSecCounter']),
    convertedExpInSecCounter() {
      var timeInSec = this.getExpInSecCounter;
      var min = ~~(timeInSec / 60);
      return this.toStringFragment(min);
    },
  },
  methods: {
    toStringFragment(timeFragment) {
      return timeFragment > 9 ? timeFragment : '0' + timeFragment;
    },
  },
  watch: {
    getExpInSecCounter(newValue) {
      if (newValue <= SECONDS_TO_TRIGGER_LOGOUT_DIALOG) {
        this.$refs.beforeLogoutDialog.open();
      }
      if (newValue == SECONDS_TO_TRIGGER_LOGOUT_DIALOG) {
        this.$refs.beforeLogoutDialog.notificationIfNotFocused();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>